(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comely-search-recent')) {
    customElements.define('comely-search-recent', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        const dialog = this.closest('dialog');
        dialog?.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          dialog.querySelector('[ref="closeButton"]')?.click();
        });

        let recentIds = [];
        try {
          recentIds = (localStorage.getItem('theme4:recently:id') || '').split(',').filter(Boolean);
        } catch (error) {
          recentIds = [];
        }

        const templates = new Map(
          Array.from(this.querySelectorAll('template[data-comely-search-product]')).map((template) => [template.dataset.comelySearchProduct, template])
        );
        const recentCards = recentIds
          .map((id) => templates.get(id)?.content.firstElementChild?.cloneNode(true))
          .filter(Boolean)
          .slice(0, 4);

        if (recentCards.length) {
          this.querySelector('[data-comely-search-cards]')?.replaceChildren(...recentCards);
          const title = this.querySelector('[data-comely-search-title]');
          if (title) title.textContent = this.dataset.recentlyViewed;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
